import React, { memo } from "react";
import { useTranslation, Trans } from "react-i18next";
import { P1 } from "@talentbait/shared-components";

import DraftCampaignStepLayout from "./DraftCampaignStepLayout";

const DraftCampaignAiInfoStep = (props) => {
  const { t } = useTranslation();

  return (
    <DraftCampaignStepLayout header={t("Artificial intelligence support ⭐️")} {...props}>
      <Trans parent={P1}>
        Behind the scenes, our AI diligently <b>reviews your career page</b> to streamline the
        campaign booking experience for you.
      </Trans>
      <Trans parent={P1}>
        With our <b>intelligent campaign booking</b>, we extract essential information and suggest a
        data-driven channel mix precisely tailored for your target audience.
      </Trans>
    </DraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignAiInfoStep);
